import React from "react"
import {Home,
        Archive,
        AlertCircle,
        Map,
        Plus,
        FileText,
        UserCheck,
        List,
        Calendar,
        User,
        Users,
        PieChart,
        Tag,
        Clock,
        Lock,
        Package
        } from "react-feather"
const navigationConfig = [
  {
    type: "groupHeader",
    groupTitle: "Dashboard"
  },
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/"
  },
  {
    id: "locations",
    title: "Locations",
    type: "item",
    icon: <Lock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/locations"
  },
  /*{
    type: "groupHeader",
    groupTitle: "Assets"
  },
  {
    id: "dashboard-assets",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/dashboard-assets"
  },
  {
    id: "assets",
    title: "Assets",
    type: "item",
    icon: <Tag size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/assets"
  },
  {
    id: "asset-logs",
    title: "Asset Logs",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/assets-logs"
  },
  {
    id: "assetCategories",
    title: "Asset Categories",
    type: "item",
    icon: <List size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/asset-categories"
  },
  {
    id: "asset-users",
    title: "Asset Users",
    type: "item",
    icon: <User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/asset-users"
  },
  {
    id: "user-groups-assets",
    title: "User Groups",
    type: "item",
    icon: <Users size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/user-groups-assets"
  },
  {
    id: "schedules",
    title: "Schedules",
    type: "item",
    icon: <Clock size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/schedules"
  },*/
  {
    type: "groupHeader",
    groupTitle: "Office"
  },
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={20} />,
    permissions: [],
    navLink: "/dashboard-office"
  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <User size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/office-users"
  },
  {
    id: "activity",
    title: "Activity",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/activity"
  },
  {
    id: "expiredLockers",
    title: "Expired Lockers",
    type: "item",
    icon: <Clock size={20} />,
    permissions: [],
    navLink: "/expired-lockers"
  },
  // {
  //   type: "groupHeader",
  //   groupTitle: "Orders",
  // },
  {
    id: "dashboard-delivery",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={20} />,
    permissions: [],
    navLink: "/dashboard-delivery"
  },
  {
    id: "new-order",
    title: "New Order",
    type: "item",
    icon: <Plus size={20} />,
    permissions: [],
    navLink: "/orders/details/new"
  },
  {
    id: "orders",
    title: "Orders List",
    type: "item",
    icon: <List size={20} />,
    permissions: [],
    navLink: "/orders"
  },
  {
    id: "deposited-orders",
    title: "Deposited Orders",
    type: "item",
    icon: <Package size={16} />,
    permissions: [],
    navLink: "/deposited-orders"
  },
  {
    id: "orders-history",
    title: "Orders History",
    type: "item",
    icon: <Calendar size={20} />,
    permissions: [],
    navLink: "/orders-history"
  },
  {
    id: "archived-orders",
    title: "Archived Orders",
    type: "item",
    icon: <Archive size={20} />,
    permissions: [],
    navLink: "/archived-orders"
  },
  {
    id: "orders_logs",
    title: "Orders Logs",
    type: "item",
    icon: <FileText size={20} />,
    permissions: [],
    navLink: "/orders-logs"
  },
  {
    id: "delivery-analytics",
    title: "Delivery Analytics",
    type: "item",
    icon: <PieChart size={20} />,
    permissions: [],
    navLink: "/delivery-analytics"
  },
  {
    type: "groupHeader",
    groupTitle: "Notifications"
  },
  {
    id: "alerts",
    title: "Alerts",
    type: "item",
    icon: <AlertCircle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/alerts"
  },
  {
    id: "locationsDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/locations/details/:id"
  },
  {
    type: "groupHeader",
    groupTitle: "Administration"
  },
  {
    id: "admins",
    title: "Admins",
    type: "item",
    icon: <UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins"
  },
  {
    id: "adminsLogs",
    title: "Admins Logs",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins/logs"
  },
  // {
  //   id: "user-groups-office",
  //   title: "User Groups",
  //   type: "item",
  //   icon: <Users size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/user-groups-office"
  // },
  /*{
    id: "newLocation",
    title: "New Location",
    type: "item",
    icon: <Map size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/locations/config/new"
  },*/
  /*{
    id: "import-orders",
    title: "Import Orders",
    type: "item",
    icon: <UploadCloud size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/import-orders"
  },*/
  /*{
    id: "administration",
    title: "Administration",
    icon: <Settings size={20} />,
    type: "collapse",
    children: [
      {
        id: "admins",
        title: "Admins",
        type: "item",
        icon: <UserCheck size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/admins"
      },
      {
        id: "projects",
        title: "Projects",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/projects"
      },
      {
        id: "userType",
        title: "User Type",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/user-type"
      },
      {
        id: "service",
        title: "Service",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/service"
      }
    ]
  },*/
  {
    id: "usersDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/users/details/:id"
  },
  /*{
    id: "serviceStatus",
    title: "Service Status",
    type: "item",
    icon: <Server size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/service-status"
  },*/
  /*{
  id: "support",
  title: "Support",
  type: "item",
  icon: <LifeBuoy size={20} />
  },
  {
    id: "docs",
    title: "Documentation",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    icon: <HelpCircle size={20} />,
    permissions: ["admin"],
  }*/
]

export default navigationConfig
